import { calculateBeginTeamDashboardStatus,handleRewardStatus, sortLeaderUser, sortByDateKey, getSplitText, getMaxTeamSize, getDateForAPI } from "../utill.func";
import { CHALLENGE, LINE_REGISTER_STATUS, PERIOD_DATA_MAPPING, teamMaxSize, minContent, maxTeamSteps, USER_DEVICE_REGEX, CHALLENGE_BEGIN_KEY_MAPPING, BEGIN_CHALLENGE_SCORE_KEY_MAPPING, BEGIN_MEMBER_SCORE_TARGET, BEGIN_MEMBER_PASS_SCORE } from "../common/challengeConstants";



export class BeginChallengeTeamDashboard {
    constructor(data) {
        if (data) {
            this.rewardEndDate = data?.challengeData?.challengeRewardDate || data?.challengeData?.completeDate || '';
            this.challengeType = data?.challengeType || CHALLENGE.type.TEAM;
            this.teamFullSize = getMaxTeamSize(data?.challengeType);
            this.teamDashboardStatus = calculateBeginTeamDashboardStatus(data?.approve_date, data?.team_size, data?.complete60_date, data.end_challenge, data?.complete_team_in, data.weightout_date, this.rewardEndDate, this.teamFullSize, data?.challenge_date) || '';
            this.end_challenge = data.end_challenge || ''
            this.weightoutDate = data.weightout_date || '';
            this.weightoutStartDate = data.weightout_date?.start_date || '';
            this.weightoutEndDate = data.weightout_date?.end_date || '';
            this.teamId = data?.id || '';
            this.eventId = data?.event_id || '';
            this.challengeDay = data?.challenge_date || '-';
            this.completeTeamDate = data?.complete_team_in || '';
            this.approvalTeamdate = data?.approve_date || '';
            this.teamName = data?.name || '';
            this.teamSize = data?.team_size || 0;
            this.fullTeamRegistered = (parseInt(data?.team_size) == getMaxTeamSize(data?.challengeType)) ? true : false;
            this.completedDate = data?.complete60_date || '';
            this.eventData = data?.event ? new Event(data?.event) : null;
            this.users = mapAndSortUsers(data?.users, data?.partyId) || [];
            const sortedLeaderUsers = sortRegisteredUser(data?.users);
            const sortedLoggedInUsers = sortLoggedInUser(data?.users, data?.partyId);
            this.teamTotalChecklistScore = sumTeamScores(this.users);
            this.avgChecklistScorePerMember = calculateTeamAvgScore(this.users);
            this.membersWithChecklistScore = calculateChecklistPassedUsers(this.users);
            const currentUser = this.users?.find(user => user.partyId === data?.partyId);
            this.currentUserHealthspanScore = currentUser?.registerUserData?.healthspan_score || 0;
            this.currentUserHealthspanScoreTarget = this.currentUserHealthspanScore
                ? Math.min(+(this.currentUserHealthspanScore * 1.1).toFixed(1), 100)
                : 0;
            this.currentUserWeightoutHealthspanScore = currentUser?.weightOutUserData?.healthspan_score || 0;
            this.currentUserSubmittedChecklistToday = currentUser?.hasSubmittedChecklistToday || false;
            
            //Team Party Ids and User Data
            this.challengePartyIds = sortedLoggedInUsers?.map(user => user?.party_id) || [];
            this.challengeUserData = sortedLoggedInUsers?.map(user => new UserDataModel(user)) || [];

            if ((sortedLoggedInUsers && sortedLoggedInUsers.length > 0)) {
                //filter weightin and weightout data
                const registeredData = getUsersPeriodFilterData(sortedLoggedInUsers, PERIOD_DATA_MAPPING.registerPeroid);
                const weightOutData = getUsersPeriodFilterData(sortedLoggedInUsers, PERIOD_DATA_MAPPING.weightOutPeriod);

                // Team Body composition card
                this.hasTeamWeighOut = weightOutData.filter(Boolean).length == getMaxTeamSize(data?.challengeType);
                this.hasUserWeighOut = getPeriodFindData(sortedLoggedInUsers.find(user => user?.party_id == data?.partyId), PERIOD_DATA_MAPPING.weightOutPeriod);
            }

            this.defaultTeamSteps = (!this.fullTeamRegistered ? minContent : maxTeamSteps);
            // Team Rewards List
            this.teamRewards = sortedLoggedInUsers?.reduce((acc, curr) => {
                filterRewards(curr?.user_rewards, 'team', acc);
                return acc;
            }, []);

        }
    }
}

export class Event {
    constructor(eventData) {
        this.eventId = eventData?.id || '';
        this.eventName = eventData?.name || '';
        this.startDate = eventData?.start_date || '';
        this.endDate = eventData?.end_date || '';
        this.eventType = eventData?.type || 'CAMPAIGN';
        this.eventSlug = eventData?.slug || '';
    }
}

export class Users {
    constructor(userData) {
        //Used for userInfo data
        this.challengeUserId = userData?.id || '';
        this.userName = userData?.name || '';
        this.aboId = userData?.abo_id || '';
        this.partyId = userData?.party_id || '';
        this.isLeader = userData?.is_leader || false;
        this.isNewMember = userData?.is_new_member && (userData?.business_nature).toLowerCase() == CHALLENGE.teamDashboard.businessMember || false;
        this.isNewAbo = userData?.is_new_member && (userData?.business_nature).toLowerCase() == CHALLENGE.teamDashboard.businessOwner || false;
        this.myRewards = filterRewards(userData?.user_rewards) || [];
        this.firstName = getSplitText(this.userName, 0, ' ');
        this.lastName = getSplitText(this.userName, 1, ' ');


        if (userData?.user_scores) {
            const userScores = userData?.user_scores;
            this.userTotalChecklistScore = filterUserScoresWithMasterId(userScores, 'score')?.score_details[0]?.total_score || 0;
            this.hasPassedChecklist = filterUserScoresWithMasterId(userScores, 'score')?.score_details[0]?.is_pass || false;
            this.passScore = filterUserScoresWithMasterId(userScores, 'score')?.score_details[0]?.pass_score || BEGIN_MEMBER_PASS_SCORE;
            this.maxScore = filterUserScoresWithMasterId(userScores, 'score')?.score_details[0]?.max_score || BEGIN_MEMBER_SCORE_TARGET;
            const todayLog = filterUserScoresWithMasterId(userScores, 'score')?.score_details[0]?.daily_logs?.find(
                (log) => log?.date === getDateForAPI(new Date())
            );
            this.hasSubmittedChecklistToday = todayLog?.is_complete_begin_checklist === true;
        }

        if (userData?.user_periods) {
            this.userPeriods = userData?.user_periods || '';
            const registerPeriods = getPeriodFindData(userData, PERIOD_DATA_MAPPING.registerPeroid);
            const weightOutPeriods = getPeriodFindData(userData, PERIOD_DATA_MAPPING.weightOutPeriod);
            this.hasUserWeighOut = weightOutPeriods && weightOutPeriods?.params ? true : false;
            // Health data of user
            this.registerUserData = renderUserHealthData(registerPeriods) || '';
            this.dailyUserData = renderUserHealthData(registerPeriods, 'daily') || '';
            this.weightOutUserData = renderUserHealthData(weightOutPeriods) || '';

            this.phoneNumber = registerPeriods?.params?.period_phone || '';
            this.userDevice = (registerPeriods?.params?.device)?.replace(USER_DEVICE_REGEX, '') || '';

            if (this.hasUserWeighOut) {
                this.userFatChange = getValueFromParams(weightOutPeriods?.params, 'cal', 'fat_mass_change') || 0;
                this.userMuscleChange = getValueFromParams(weightOutPeriods?.params, 'cal', 'muscle_mass_change') || 0;
                this.userWeightChange = getValueFromParams(weightOutPeriods?.params, 'cal', 'weight_change') || 0;

            } else {
                this.userFatChange = getValueFromParams(registerPeriods?.params, 'daily', 'fat_change') || 0;
                this.userMuscleChange = getValueFromParams(registerPeriods?.params, 'daily', 'muscle_change') || 0;
                this.userWeightChange = getValueFromParams(registerPeriods?.params, 'daily', 'weight_change') || 0;
            }


        }
    }
}

//only to set uername, partyIds
export class UserDataModel {
    constructor(userData) {
        this.userName = userData?.name || '';
        this.aboId = userData?.abo_id || '';
        this.partyId = userData?.party_id || '';
        this.firstName = getSplitText(this.userName, 0, ' ');
        this.lastName = getSplitText(this.userName, 1, ' ');
        this.isLeader = userData?.is_leader || false;
    }
}

export class UserDetailModel {
    constructor(userDetail) {
        const lineUsers = userDetail?.filter(detail => detail.registerStatus = LINE_REGISTER_STATUS);
        this.lineUserData = Array.from({ length: teamMaxSize }, (_, i) => {
            const lineUser = lineUsers[i];
            return {
                partyId: lineUser?.partyId || '',
                displayName: lineUser?.displayName || '',
                pictureUrl: lineUser?.pictureUrl || ''
            };
        });
    }
}

export class UserRewardModel {
    constructor(userReward) {
        this.rewardId = userReward?.reward_id || '';
        this.rewardStatus = userReward?.status || '';
        this.rewardClaimDate = userReward?.claim_date || '';
        this.rewardUserId = userReward?.rewards?.id || '';
        this.rewardEventId = userReward?.reward?.event_id || '';
        this.rewardImage = userReward?.reward?.image_url || '';
        this.rewardName = userReward?.reward?.name || '';
        this.rewardPrice = userReward?.reward?.price || '';
        this.rewardShortName = userReward?.reward?.short_name || '';
        this.rewardSku = userReward?.reward?.sku || '';
        this.rewardImagesendLine = userReward?.reward?.image_send_line || '';
        this.rewardStatusIconAndTitle = this.rewardStatus ? handleRewardStatus(this.rewardStatus) : '';
        this.rewardDescription = userReward?.reward?.product_description || '';
        this.rewardActualName = userReward?.reward?.name_send_line || '';

    }
}


export const calculateAvg = (value, avgVal) => {
    return (value / avgVal);
}

const filterUserScoresWithMasterId = (userScores, key) => {
    return userScores?.find((scoreId) => scoreId?.score_master?.id === BEGIN_CHALLENGE_SCORE_KEY_MAPPING[key].id);
}


const getValueFromParams = (params, key, keyMap) => {
    if (!params || typeof params !== 'object') {
        return null;
    }
    if (typeof params[key] === 'object' && params[key][keyMap] !== undefined) {
        return params[key][keyMap];
    } else {
        return params[keyMap];
    }
}

const getPeriodFindData = (userData, key) => {
    return userData?.user_periods?.find(data => data?.period.type === key);
}

const getUsersPeriodFilterData = (users, key) => {
    return users?.map((userData) => {
        return getPeriodFindData(userData, key);
    })
}

const mapAndSortUsers = (users, currentPartyId) => {
    const userData = users.map(user => new Users(user, currentPartyId));

    //todo: ask por if sorting to be done on healthspanscores
    const sortedByHealthSpanScores = userData.sort((a, b) => b.registerUserData?.healthspan_score - a.registerUserData?.healthspan_score);
    sortedByHealthSpanScores.forEach((user, index) => {
        user.userRank = index + 1;
    });

    const sortedAndPrioritized = sortedByHealthSpanScores.sort((a, b) => {
        if (a.partyId === currentPartyId && b.partyId !== currentPartyId) return -1;
        if (a.partyId !== currentPartyId && b.partyId === currentPartyId) return 1;
        return 0;
    });
    return sortedAndPrioritized;
}

const accumulateData = (value) => {
    const data = value.map(Number);
    return data.reduce((acc, curr) => acc + curr, 0);
}


const renderUserHealthData = (data, dataSet = '') => {
    const bodyData = {}
    Object.keys(CHALLENGE_BEGIN_KEY_MAPPING).forEach(metricKey => {
        const keyMap = CHALLENGE_BEGIN_KEY_MAPPING[metricKey];
        const keySet = dataSet == 'daily' ? dataSet : keyMap?.key;
        const keySetMap = dataSet == 'daily' ? keyMap?.key : keyMap?.key_map;
        const userData = getValueFromParams(data?.params, keySet, keySetMap) || 0;
        return bodyData[metricKey] = userData;
    });
    return bodyData;
}

const filterRewards = (userRewards, key, acc) => {
    return userRewards?.filter(data => data?.status === CHALLENGE.reward.waiting_to_received || data?.status === CHALLENGE.reward.not_qualified || data?.status === CHALLENGE.reward.received)
        .map(reward => {
            if (key == 'team') {
                return acc.push(new UserRewardModel(reward));
            } else {
                return new UserRewardModel(reward);
            }
        });
}

export const sortRegisteredUser = (users) => {
    const sortedByDate = sortByDateKey(users, 'created_at');
    return sortLeaderUser(sortedByDate);
};

export const sortLoggedInUser = (users, currentPartyId, dateKey = 'created_at') => {
    return users.sort((a, b) => {
        if (a.party_id === currentPartyId && b.party_id !== currentPartyId) return -1;
        if (a.party_id !== currentPartyId && b.party_id === currentPartyId) return 1;

        return new Date(a[dateKey]) - new Date(b[dateKey]);
    });
};

const getValidScores = (users) => {
    return (users || [])
        .map(user => user?.userTotalChecklistScore)
        .filter(score => typeof score === 'number' && !isNaN(score));
}

const sumTeamScores = (users) => {
    return accumulateData(getValidScores(users));
}

const calculateTeamAvgScore = (users) => {
    const scores = getValidScores(users);
    if (!scores.length) {
        return 0;
    }
    return calculateAvg(sumTeamScores(users), scores.length);
}

const calculateChecklistPassedUsers = (users) => {
    return users.filter(user => user.hasPassedChecklist)?.length || 0;
}

